// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"475":"aef8d4cf","580":"504e04b8","747":"5b1973b5"}[chunkId] + ".chunk.css";
};